import ReportsContainer from "../../container/admin/reports-container";

const Reports = (props) => {
    return <ReportsContainer {...props} />;
};

export default Reports;